import React from "react";

import cx from "classnames";

import styles from "./Spacer.scss";

const sizeMap = {
  default: styles.default,
  large: styles.large,
  small: styles.small,
  medium: styles.medium,
  little: styles.little,
  "extra-large": styles["extra-large"],
  tiny: styles.tiny,
};

/**
 * Props for the Spacer component.
 */
interface SpacerProps {
  /**
   * Size of the spacing
   */
  size?:
    | "tiny"
    | "small"
    | "little"
    | "default"
    | "medium"
    | "large"
    | "extra-large";
  /**
   * If a "strict" prop is provided, the spacer will not resize based on the screen dimensions
   */
  strict?: boolean;
  /**
   * The orientation of the spacer. Vertical gives it height; horizontal gives it width.
   */
  orientation?: "horizontal" | "vertical";
  /**
   * If passed in, puts a visible border on the spacer. Useful for testing and debugging!
   */
  outline?: boolean;
}

/**
 * Rather than continuing to write CSS for each spacing amount between
 * items on the page, we can use this helper. It's fully responsive and
 * provides a strict mode for avoiding media queries if necessary.
 */
export function Spacer({
  size = "default",
  orientation = "vertical",
  ...props
}: SpacerProps) {
  const className = cx(styles.spacer, sizeMap[size], {
    [styles.responsive]: !props.strict,
    [styles.horizontal]: orientation === "horizontal",
    [styles.vertical]: orientation === "vertical",
    [styles.outline]: props.outline,
  });
  return <div className={className} />;
}
